import React, { Component } from 'react';
import DarkThemeNav from '../common/dark-theme-nav';

class Progress extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
    <section><a className="anchor" id="progress"></a>
    <h2>Progress Indicators</h2>
    { this.props.staticVersion === false ? (
      <Included
      onClick={() => this.props.onIncludeClick()}
      included={this.props.included}/>
    ) : ( '' ) }
    <br/>
    <p>Defaults to 0% progress. Add a inline style to control the progress meter</p>

    <div className="progress">
      <span className="progress--meter" role="progressbar" aria-valuenow="0"
  aria-valuemin="0" aria-valuemax="100"></span>
    </div>
    <div className="progress">
      <span className="progress--meter" role="progressbar" aria-valuenow="60"
  aria-valuemin="0" aria-valuemax="100" style={{"width":"60%"}}>60%</span>
    </div>
    <div className="progress">
      <span className="progress--meter" role="progressbar" aria-valuenow="80"
  aria-valuemin="0" aria-valuemax="100" style={{"width":"80%"}}>80%</span>
    </div>
      <h2>Progress Indicators</h2>
      <p>Defaults to 0% progress. Add a inline style to control the progress meter.</p>
      <p>For the various sizes, add progress--small, progress--medium, or progress--large.</p>
      <DarkThemeNav anchor="progress" />
      <div className="soft">
        <div className={'progress progress--small'}>
          <span className="progress--meter" role="progressbar" aria-valuenow="0"
      aria-valuemin="0" aria-valuemax="100" style={{"width":"45%"}}>45%</span>
        </div>
        <div className="progress progress--medium">
          <span className="progress--meter" role="progressbar" aria-valuenow="60"
      aria-valuemin="0" aria-valuemax="100" style={{"width":"60%"}}>60%</span>
        </div>
        <div className="progress progress--large">
          <span className="progress--meter" role="progressbar" aria-valuenow="80"
      aria-valuemin="0" aria-valuemax="100" style={{"width":"80%"}}>80%</span>
        </div>
        <br/>
      </div>
    <br/>
    <pre><code className="language-html">{`<div class="progress">
  <span class="progress--meter" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></span>
</div>
<div class="progress">
  <span class="progress--meter" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:60%">60%</span>
</div>
<div class="progress">
  <span class="progress--meter" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width:80%">80%</span>
</div>`}</code></pre>
    <br/>
    <hr/>
    </section>
  )
}
}

export default Progress



// WEBPACK FOOTER //
// ./styleguide/components/sections/Progress.js